import styles from './ui.module.css'

/** Centred spinner and a short line saying what is loading. */
export function LoadingState({ label }) {
  return (
    <div className={styles.loadingState} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden="true" />
      <span>{label}</span>
    </div>
  )
}
